module.exports = "https://static.im-cdn.com/mjc/storefront/Spring/static/media/Linkedin.46a5944e.svg";